import { parseChildren } from '../core.parse-children.js';

function makeHtmlNodeParser(getParsers) {
  let parsers;
  const parseHtmlNode2 = (node, context) => {
    if (!parsers) {
      parsers = getParsers ? { ...allHtmlParsers, ...getParsers() } : allHtmlParsers;
    }
    const attributes = Array.from(node.attributes).map((it) => [it.nodeName, it.nodeValue]).filter((it) => it[1] !== null);
    const children = parseChildren(node, parsers, context.depth + 1);
    const output = {
      nodeType: "html",
      tagName: node.tagName.toLowerCase()
    };
    if (attributes.length > 0) {
      output.attributes = Object.fromEntries(attributes);
    }
    if (children.length > 0) {
      output.children = children;
    }
    return output;
  };
  return parseHtmlNode2;
}
const parseHtmlNode = makeHtmlNodeParser();
const simpleHtmlParsers = {
  b: parseHtmlNode,
  br: parseHtmlNode,
  div: parseHtmlNode,
  em: parseHtmlNode,
  i: parseHtmlNode,
  strong: parseHtmlNode,
  sub: parseHtmlNode,
  sup: parseHtmlNode,
  u: parseHtmlNode,
  wbr: parseHtmlNode
};
const paragraphHtmlParsers = {
  li: parseHtmlNode,
  ol: parseHtmlNode,
  p: parseHtmlNode,
  ul: parseHtmlNode
};
const headingHtmlParsers = {
  h1: parseHtmlNode,
  h2: parseHtmlNode,
  h3: parseHtmlNode,
  h4: parseHtmlNode,
  h5: parseHtmlNode,
  h6: parseHtmlNode
};
const tableHtmlParsers = {
  table: parseHtmlNode,
  tbody: parseHtmlNode,
  td: parseHtmlNode,
  tfoot: parseHtmlNode,
  th: parseHtmlNode,
  thead: parseHtmlNode,
  tr: parseHtmlNode
};
const allHtmlParsers = {
  ...simpleHtmlParsers,
  ...paragraphHtmlParsers,
  ...headingHtmlParsers,
  ...tableHtmlParsers,
  a: parseHtmlNode,
  abbr: parseHtmlNode,
  address: parseHtmlNode,
  area: parseHtmlNode,
  article: parseHtmlNode,
  aside: parseHtmlNode,
  audio: parseHtmlNode,
  bdi: parseHtmlNode,
  bdo: parseHtmlNode,
  blockquote: parseHtmlNode,
  button: parseHtmlNode,
  canvas: parseHtmlNode,
  caption: parseHtmlNode,
  cite: parseHtmlNode,
  code: parseHtmlNode,
  col: parseHtmlNode,
  colgroup: parseHtmlNode,
  data: parseHtmlNode,
  dd: parseHtmlNode,
  del: parseHtmlNode,
  details: parseHtmlNode,
  dfn: parseHtmlNode,
  dl: parseHtmlNode,
  dt: parseHtmlNode,
  figcaption: parseHtmlNode,
  figure: parseHtmlNode,
  footer: parseHtmlNode,
  header: parseHtmlNode,
  hgroup: parseHtmlNode,
  hr: parseHtmlNode,
  iframe: parseHtmlNode,
  img: parseHtmlNode,
  ins: parseHtmlNode,
  map: parseHtmlNode,
  mark: parseHtmlNode,
  nav: parseHtmlNode,
  output: parseHtmlNode,
  picture: parseHtmlNode,
  pre: parseHtmlNode,
  q: parseHtmlNode,
  rp: parseHtmlNode,
  rt: parseHtmlNode,
  ruby: parseHtmlNode,
  s: parseHtmlNode,
  samp: parseHtmlNode,
  section: parseHtmlNode,
  small: parseHtmlNode,
  source: parseHtmlNode,
  span: parseHtmlNode,
  style: () => null,
  summary: parseHtmlNode,
  time: parseHtmlNode,
  track: parseHtmlNode,
  var: parseHtmlNode,
  video: parseHtmlNode
};
function makeAllHtmlParser(parser) {
  return Object.fromEntries(
    Object.keys(allHtmlParsers).map((key) => [key, parser])
  );
}

export { allHtmlParsers, headingHtmlParsers, makeAllHtmlParser, makeHtmlNodeParser, paragraphHtmlParsers, parseHtmlNode, simpleHtmlParsers, tableHtmlParsers };
//# sourceMappingURL=common.html.js.map
